import { User, Phone, Mail, Cake, Building2 } from 'lucide-react';

interface ContactCardProps {
  data: {
    name?: string;
    phone?: string;
    email?: string;
    photo?: string;
    birthday?: string;
    company?: string;
  };
}

export default function ContactCard({ data }: ContactCardProps) {
  return (
    <div className="my-2 border border-cyan-500/30 bg-[#0a1628]/80 backdrop-blur-sm p-3 max-w-[320px]"
         style={{ clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))' }}>
      <div className="flex items-center gap-3 mb-2">
        {data.photo ? (
          <img
            src={`data:image/jpeg;base64,${data.photo}`}
            alt={data.name}
            className="w-12 h-12 rounded-full border-2 border-cyan-500/50 object-cover"
          />
        ) : (
          <div className="w-12 h-12 rounded-full border-2 border-cyan-500/50 bg-cyan-500/10 flex items-center justify-center">
            <User className="w-6 h-6 text-cyan-400" />
          </div>
        )}
        <div>
          <div className="text-cyan-300 font-semibold text-sm">{data.name || 'Unknown'}</div>
          {data.company && (
            <div className="text-gray-400 text-xs flex items-center gap-1">
              <Building2 className="w-3 h-3" />
              {data.company}
            </div>
          )}
        </div>
      </div>

      <div className="space-y-1 text-xs">
        {data.phone && (
          <a href={`tel:${data.phone}`} className="flex items-center gap-2 text-gray-300 hover:text-cyan-300 transition-colors">
            <Phone className="w-3.5 h-3.5 text-cyan-500/70" />
            <span className="font-mono">{data.phone}</span>
          </a>
        )}
        {data.email && (
          <a href={`mailto:${data.email}`} className="flex items-center gap-2 text-gray-300 hover:text-cyan-300 transition-colors">
            <Mail className="w-3.5 h-3.5 text-cyan-500/70" />
            <span>{data.email}</span>
          </a>
        )}
        {data.birthday && (
          <div className="flex items-center gap-2 text-gray-300">
            <Cake className="w-3.5 h-3.5 text-purple-400/70" />
            <span>{data.birthday}</span>
          </div>
        )}
      </div>
    </div>
  );
}
